import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const safetyApi = createApi({
    reducerPath: "core/safety",
    baseQuery: axiosBaseQuery,
    tagTypes: ["safetyList"],
    endpoints: (builder) =>({
        safetyFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['safetyList'],
            query: (query = '') => ({
                url: "core/safety/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        safetyCreate: builder.mutation({
            invalidatesTags: ['safetyList'],
            query: (data)=>({url: "core/safety/", method: "POST", data})
        }),
        safetyUpdate: builder.mutation({
            invalidatesTags: ['safetyList'],
            query: (data)=>({url: "/core/safety/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        safetyDelete: builder.mutation({
            invalidatesTags: ['safetyList'],
            query: (id)=>({url: "/core/safety/"+id, method: "DELETE"})
        }),
    })
})

export const { useSafetyFindAllQuery, useSafetyCreateMutation, useSafetyUpdateMutation, useSafetyDeleteMutation } = safetyApi;
export {safetyApi};
